import styled from "styled-components";

export const OnEquityBadgeStyled = styled.div`
    display: inline-flex;
    align-items: center;
    background: var(--color-green-secondary);
    border-radius: 10px;
    font-size: 10px;
    color: var(--color-base);
    padding: 3px 8px 3px 2px;
`;
